import React from 'react';
import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import ApartmentIcon from '@material-ui/icons/Apartment';
import OccurrencesCard from './Occurrences';
import FailedLoginAttemptCard from './FailedLoginAttemptCard';
import EmployeesDelayCard from './EmployeesDelayCard';
import ExceedOvertimeCard from './ExceedOvertimeCard';
import InactiveEmployeesCard from './InactiveEmployeesCard';
import EmployeesTermSignedCard from './EmployeesTermSignedCard';
import EmployeesRegistersCard from './EmployeesRegistersCard';
import CardMessage from '../../../components/CardMessage/CardMessage';
import { CondominiumReducerData } from '../../../store/reducers/condominiumReducer';
import { AppState } from '../../../store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      overflowY: 'auto',
      height: 'calc(100vh - 135px)',
      display: 'flex',
      padding: theme.spacing(1),
    },
    contentMaxHeight: {
      height: '100%',
      overflowY: 'auto',
    },
    cardImage: {
      width: 30,
      height: 30,
      margin: '6px 6px 6px 0',
    },
  }),
);

const PersonnelDepartmentOverview: React.FC = () => {
  const classes = useStyles();

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  return (
    <Grid
      className={classes.mainContentContainer}
      container
      spacing={2}
      direction="column"
    >
      {condominiumSelected ? (
        <>
          <Grid container item direction="row" spacing={1}>
            <Grid item xs md={4}>
              <ExceedOvertimeCard />
            </Grid>
            <Grid item md={4}>
              <EmployeesDelayCard />
            </Grid>
            <Grid item xs md={4}>
              <FailedLoginAttemptCard />
            </Grid>
          </Grid>
          <Grid container item direction="row" spacing={1}>
            <Grid item xs md={4}>
              <InactiveEmployeesCard />
            </Grid>
            <Grid item md={4}>
              <EmployeesTermSignedCard />
            </Grid>
            <Grid item md={4}>
              <EmployeesRegistersCard />
            </Grid>
          </Grid>
          <Grid item xs className={classes.contentMaxHeight}>
            <OccurrencesCard />
          </Grid>
        </>
      ) : (
        <CardMessage
          icon={<ApartmentIcon style={{ fontSize: 130, opacity: 0.4 }} />}
          message="Selecione um condomínio"
        />
      )}
    </Grid>
  );
};

export default PersonnelDepartmentOverview;
